import { render, staticRenderFns } from "./header-pc.vue?vue&type=template&id=4ae3f72d&scoped=true&"
import script from "./header-pc.vue?vue&type=script&lang=js&"
export * from "./header-pc.vue?vue&type=script&lang=js&"
import style0 from "./header-pc.vue?vue&type=style&index=0&id=4ae3f72d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3f72d",
  null
  
)

export default component.exports